<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>渠道二维码</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        @click="handleNew"
        :loading="loading"
        >{{ loading ? '提交中' : '添加渠道码' }}</el-button
      >
      <el-table :data="list" stripe style="width: 100%">
        <el-table-column label="渠道名称" prop="name"> </el-table-column>
        <el-table-column label="用户数" align="center" prop="user_count">
          <template slot-scope="scope">
            <router-link
              :to="`/dashboard/admin/customer_users?qrcode_id=${scope.row.id}`"
              >{{ scope.row.user_count }}</router-link
            >
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{ $time(scope.row.created_at).format('YYYY-MM-DD') }}
          </template>
        </el-table-column>
        <el-table-column label="渠道码" align="center">
          <template slot-scope="scope">
            <auth-img
              tag="el-image"
              style="width: 60px; height: 60px"
              :src="scope.row.url"
              fit="cover"
            ></auth-img>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <a
              :href="scope.row.url + `?t=${FileToken}`"
              :download="`VTS Portal 渠道二维码 - ${scope.row.name}.png`"
              >下载渠道码</a
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { qrcodeList, createQrcode } from '../../service/getData'

export default {
  data() {
    return {
      list: [],
      name: '',
      loading: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await qrcodeList()
      if (res.code == 0) {
        this.list = res.data.list
      }
    },
    handleNew() {
      this.$prompt('请输入渠道名称', '添加渠道码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,20}$/,
        inputErrorMessage: '渠道名称不能为空且长度不能超过15个字',
      }).then(({ value }) => {
        this.name = value
        this.handleSubmit()
      })
    },
    async handleSubmit() {
      if (this.name) {
        this.loading = true
        let res = await createQrcode({
          name: this.name,
        })
        if (res.code == 0) {
          this.list.unshift(res.data)
          this.$message.success('添加成功')
          this.name = ''
        }
        this.loading = false
      }
    },
  },
}
</script>
